import { useEffect } from "preact/hooks";
import { playCleared } from "../../audio/sfx";
import { profile } from "../../state/store";

export function Cleared({ label, onDone }: { label: string; onDone: () => void }) {
  useEffect(() => {
    if (profile.value.settings.sound.master && profile.value.settings.sound.sfx) {
      try {
        playCleared();
      } catch {
        /* audio unavailable — the visual stamp still lands */
      }
    }
    const t = setTimeout(onDone, 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, []);

  return (
    <div class="stage stage-cleared">
      <p class="display stage-lead-sm">{label}</p>
      <p class="stage-kicker stage-cleared-tag">Cleared</p>
    </div>
  );
}
